__turbopack_context__.v({
  "addToCalendar": "calendar-alerts-module-scss-module__2BzF6a__addToCalendar",
  "body": "calendar-alerts-module-scss-module__2BzF6a__body",
  "cal": "calendar-alerts-module-scss-module__2BzF6a__cal",
  "event": "calendar-alerts-module-scss-module__2BzF6a__event",
  "eventDate": "calendar-alerts-module-scss-module__2BzF6a__eventDate",
  "eventDay": "calendar-alerts-module-scss-module__2BzF6a__eventDay",
  "eventDayShort": "calendar-alerts-module-scss-module__2BzF6a__eventDayShort",
  "eventMeta": "calendar-alerts-module-scss-module__2BzF6a__eventMeta",
  "eventMonth": "calendar-alerts-module-scss-module__2BzF6a__eventMonth",
  "eventTitle": "calendar-alerts-module-scss-module__2BzF6a__eventTitle",
  "events": "calendar-alerts-module-scss-module__2BzF6a__events",
  "eyebrow": "calendar-alerts-module-scss-module__2BzF6a__eyebrow",
  "grid": "calendar-alerts-module-scss-module__2BzF6a__grid",
  "heading": "calendar-alerts-module-scss-module__2BzF6a__heading",
  "left": "calendar-alerts-module-scss-module__2BzF6a__left",
  "right": "calendar-alerts-module-scss-module__2BzF6a__right",
  "viewAll": "calendar-alerts-module-scss-module__2BzF6a__viewAll",
  "wlink": "calendar-alerts-module-scss-module__2BzF6a__wlink",
  "wlinks": "calendar-alerts-module-scss-module__2BzF6a__wlinks",
});
